<template>
  <div class="space-y-2">
    <div class="flex items-baseline justify-end gap-2 text-right text-sm">
      <span class="text-lg font-semibold text-slate-900">{{ value }}</span>
      <span class="text-sm font-medium text-slate-500">{{ label }}</span>
    </div>

    <div class="progress-track">
      <div class="progress-segment progress-segment--primary" :style="{
        width: primaryWidth,
        backgroundColor: primaryColor
      }"></div>
      <div v-if="secondaryPercent > 0" class="progress-segment progress-segment--secondary" :style="{
        width: secondaryWidth,
        backgroundColor: secondaryColor
      }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProgressBar",
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    label: {
      type: String,
      default: ""
    },
    primaryPercent: {
      type: Number,
      default: 0
    },
    secondaryPercent: {
      type: Number,
      default: 0
    },
    primaryColor: {
      type: String,
      default: "#22c55e"
    },
    secondaryColor: {
      type: String,
      default: "#38bdf8"
    }
  },
  computed: {
    normalizedPrimaryPercent() {
      return Math.min(Math.max(this.primaryPercent, 0), 100);
    },
    normalizedSecondaryPercent() {
      return Math.min(
        Math.max(this.secondaryPercent, 0),
        100 - this.normalizedPrimaryPercent
      );
    },
    primaryWidth() {
      return `${this.normalizedPrimaryPercent}%`;
    },
    secondaryWidth() {
      return `${this.normalizedSecondaryPercent}%`;
    }
  }
};
</script>

<style scoped>
.space-y-2> :not([hidden])~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}

.progress-track {
  position: relative;
  width: 100%;
  height: 37px;
  overflow: hidden;
  background-color: white;
  border-radius: 8px;
  padding: 5px;
}

.progress-segment {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
}

.progress-segment--primary {
  border: 5px solid #F0FDF4;
  border-radius: 8px;
}

.progress-segment--secondary {
  border-radius: 0 8px 8px 0;
  left: auto;
  right: 0;
  border: 5px solid white;
  border-left: none;


}
</style>
